
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWebTeamScore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matchDayId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"viewType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWebTeamScore"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"matchDayId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matchDayId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"viewType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"viewType"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentTicker"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tickerText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalScore"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clubNum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"club1Total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"club2Total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rank"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rounds"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roundIndex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"playForm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"strokes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"team1Total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"team2Total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"players"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opponentName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clubName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hcp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"playedHoles"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showTeetime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"strokes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"strokesIN"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"strokesOUT"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scoreOpponent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scoreLabel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scoresLabel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scoresLabelOpponent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partnerNum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isStreicher"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scores"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pars"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showScorecard"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":891}};
    doc.loc.source = {"body":"query getWebTeamScore($matchDayId: Float!, $viewType: Int!) {\n  getWebTeamScore(input: {\n        matchDayId: $matchDayId, viewType: $viewType\n    }) {\n    currentTicker {\n      tickerText\n      id\n    }\n    teams {\n      name\n      totalScore\n      clubNum\n      club1Total\n      club2Total\n      rank\n      rounds {\n        roundIndex\n        playForm\n        strokes\n        score\n        team1Total\n        team2Total\n        players {\n          name\n          flag\n          opponentName\n          clubName\n          hcp\n          playedHoles\n          showTeetime\n          strokes\n          strokesIN\n          strokesOUT\n          score\n          scoreOpponent\n          scoreLabel\n          isCompleted\n          scoresLabel\n          scoresLabelOpponent\n          partnerNum\n          isStreicher\n          scores\n          pars\n          showScorecard\n        }\n      }\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getWebTeamScore"] = oneQuery(doc, "getWebTeamScore");
        
